module.exports = __webpack_public_path__ + "RU.png?75e6e2c9778162a51f2e7dea5b3d053b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/RU.png
// module id = 401
// module chunks = 0